module.exports = __webpack_public_path__ + "img/horizontal_7_5_7042.062a1f44.png";